import ReactDOM from "react-dom";
import { ButtonClose, ButtonSiguiente } from "../ui";
import { FormData3 } from "@/types";

// 🔹 Tipo para representar empresas
type Empresa = { id: string; nombre: string };

// 🔹 Props del componente, extendiendo FormData3 pero omitiendo onAddImage
export interface PopupProps extends Omit<FormData3, "onAddImage"> {
  isOpen: boolean;                     // Indica si el popup está abierto
  onClose?: () => void;                 // Función para cerrar el popup
  empresas?: Empresa[];                 // Lista de empresas disponibles
  onSelectEmpresa?: (empresas: Empresa[]) => void; // Callback al seleccionar empresa(s)
  isLoading?: boolean;                  // Indicador de carga
  errorMsg?: string;                    // Mensaje de error opcional
  children?: React.ReactNode;           // Elementos hijos opcionales
}

const PopupEmpresas: React.FC<PopupProps> = ({
  isOpen,
  onClose,
  empresas,
  onSelectEmpresa,
  isLoading,
  errorMsg,
  children,
}) => {
  // 🔹 Si el popup no está abierto, no renderizamos nada
  if (!isOpen) return null;

  // 🔹 Usamos directamente todas las empresas, sin filtrar por nombre
  const empresasParaMostrar = empresas ?? [];

  // 🔹 Usamos React Portal para renderizar el popup sobre el body
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-80 flex items-center justify-center overflow-hidden">
      <div className="relative max-h-[96vh] w-full max-w-md overflow-y-auto bg-white rounded-xl p-8 shadow-lg border-blue-700 border-r-4 border-t-2 border-b-2">
        
        {/* Título del popup */}
        <h2 className="text-lg font-semibold mb-4 dark:text-zinc-800">
          Selecciona una empresa para editarla.
        </h2>

        {/* 🔹 Manejo de estados: cargando, error o lista de empresas */}
        {isLoading ? (
          <div className="text-center py-10 text-zinc-700">
            🔄 Cargando empresas...
          </div>
        ) : errorMsg ? (
          <div className="text-center text-red-600 py-4">{errorMsg}</div>
        ) : empresasParaMostrar.length > 0 ? (
          <ul className="space-y-2">
            {empresasParaMostrar.map((empresa) => (
              <li key={empresa.id}>
                <ButtonSiguiente
                  className="w-full rounded-md px-4 py-2 hover:bg-zinc-800 shadow-sm"
                  onClick={() => onSelectEmpresa?.([empresa])} // enviamos como array
                >
                  {empresa.nombre}
                </ButtonSiguiente>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-center">No se encontraron empresas asociadas.</p>
        )}

        {/* 🔹 Renderizamos elementos hijos opcionales */}
        {children}

        {/* 🔹 Botón para cerrar el popup */}
        <ButtonClose
          onClick={onClose}
          className="absolute top-2 right-2  p-1"
        />
      </div>
    </div>,
    document.body
  );
};

export default PopupEmpresas;
